import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-summarize-data-list',
  templateUrl: './summarize-data-list.component.html',
  styleUrls: ['./summarize-data-list.component.scss']
})
export class SummarizeDataListComponent {

  @Input() summary:any;


  changeNewLine(bot:any){
    if(bot.hasOwnProperty("bot_answer")){
      return bot['bot_answer'].replace(/\n\r?/g, '<br />');
   }else{
    return bot.replace(/\n\r?/g, '<br />');
   }
  }

}
